(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apx-coa-lookup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-apx-coa-form]').forEach(function (form) {
      var productField = form.querySelector('[data-apx-coa-product]');
      var batchField = form.querySelector('[data-apx-coa-batch]');
      var section = form.closest('.apx-coa');
      var status = section.querySelector('[data-apx-coa-status]');
      var records = Array.from(section.querySelectorAll('[data-apx-coa-record]'));
      var fallback = section.querySelector('[data-apx-coa-fallback]');
      var emailLink = section.querySelector('[data-apx-coa-email]');

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var productValue = productField.value;
        var batchValue = batchField.value.trim().toLowerCase();

        records.forEach(function (record) {
          record.hidden = true;
        });

        if (!batchValue) {
          fallback.hidden = false;
          status.textContent = form.dataset.requiredMessage;
          batchField.focus();
          return;
        }

        var matches = records.filter(function (record) {
          var batchMatches = record.dataset.batch === batchValue;
          var productMatches = !productValue || record.dataset.product === productValue;
          return batchMatches && productMatches;
        });

        if (matches.length) {
          matches.forEach(function (record) {
            record.hidden = false;
          });
          fallback.hidden = true;
          status.textContent =
            matches.length +
            ' ' +
            (matches.length === 1 ? form.dataset.resultSingular : form.dataset.resultPlural);
          return;
        }

        var productLabel = productField.options[productField.selectedIndex].text;
        var subject = 'COA request - ' + batchField.value.trim();

        if (productValue) {
          subject += ' - ' + productLabel;
        }

        emailLink.href = 'mailto:help@apxvital.co.uk?subject=' + encodeURIComponent(subject);
        fallback.hidden = false;
        status.textContent = form.dataset.resultPlural.replace(/.+/, '0 ' + form.dataset.resultPlural);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apx-product-assurance"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-apx-sticky-cart]').forEach(function (stickyCart) {
      var productId = stickyCart.dataset.productId;
      var productInfo = document.querySelector('product-info[data-product-id="' + productId + '"]');
      var stickyButton = stickyCart.querySelector('[data-apx-sticky-add]');

      if (!productInfo || !stickyButton) {
        return;
      }

      var originalButton = productInfo.querySelector('button[name="add"]');
      var productForm = productInfo.querySelector('product-form');

      if (!originalButton || !productForm) {
        return;
      }

      function syncButton() {
        stickyButton.disabled = originalButton.disabled;
      }

      stickyButton.addEventListener('click', function () {
        originalButton.click();
      });

      new MutationObserver(syncButton).observe(originalButton, {
        attributes: true,
        attributeFilter: ['disabled']
      });

      new IntersectionObserver(
        function (entries) {
          var showSticky = !entries[0].isIntersecting;
          stickyCart.classList.toggle('is-visible', showSticky);
          stickyCart.setAttribute('aria-hidden', showSticky ? 'false' : 'true');
        },
        { threshold: 0.2 }
      ).observe(productForm);

      syncButton();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
